/**
 * 全站路由配置
 *
 * meta参数说明
 * keepAlive是否缓冲页面
 * isTab是否加入到tag导航
 * isAuth是否需要授权
 */
import store from "@/store";
import { Message } from "element-ui";
import NProgress from 'nprogress'; // progress bar
import Vue from 'vue';
import VueRouter from 'vue-router';

const {publicPath} = require('@/../vue.config')
const expRunPage = () => import(/* webpackChunkName: "lesson-exp-runing" */ '@/views/lesson/exp/lesson-exp-runing.vue')
const expUserList = () => import(/* webpackChunkName: "lesson-exp-user" */ '@/views/lesson/exp/lesson-exp-user.vue')
const editTestQuestion = () => import(/* webpackChunkName: "exam-testQuestion-edit" */ '@/views/exam/testQuestion/edit.vue')
const editExamPaper = () => import(/* webpackChunkName: "exam-paper-edit" */ '@/views/exam/etexampaper/edit.vue')
const userContests = () => import(/* webpackChunkName: "user-contests" */ '@/views/user/user-contests.vue')
const lessonExpMarking = () => import(/* webpackChunkName: "exp-marking" */ '@/views/lesson/exp/lesson-exp-marking.vue')
const raceExpRuning = () => import(/* webpackChunkName: "exp-runing" */ '@/views/race/exp/runing.vue')

// 重写路由的push方法
const routerPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter);

// 课堂页面
const Router = new VueRouter({
    mode: 'history', // 去掉url中的#
    base: publicPath,
    routes: [
        {
            path: '',
            name: 'index',
            component: () => import(/* webpackChunkName: "common" */ '@/components/common/index.vue'),
            redirect: {
                name: 'lessons'
            },
            children: [
                {
                    path: '/',
                    name: 'lessons',
                    component: () => import(/* webpackChunkName: "lessons" */ '@/views/lesson/lessons.vue'),
                    meta: {requireAuth: false}
                },
                {
                    path: '/lesson/:uid/type/:type',
                    name: 'lesson',
                    component: () => import(/* webpackChunkName: "lesson" */ '@/views/lesson/lesson-page.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/lesson/:lessonUid/task/handup/:uid',
                    name: 'lessonTaskHandup',
                    component: () => import(/* webpackChunkName: "lesson-task-handup" */ '@/views/lesson/task/lesson-task-handup.vue'),
                    meta: {requireAuth: true}
                }, // 上传作业
                {
                    path: '/lesson/:lessonUid/task/:uid',
                    name: 'lessonTask',
                    component: () => import(/* webpackChunkName: "lesson-task" */ '@/views/lesson/task/lesson-task-page.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/resource/:id',
                    name: 'expResource',
                    component: () => import(/* webpackChunkName: "user-exp-resource" */ '@/views/user/user-exp-resource.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/course/:expId/:expUid/lesson_exps',
                    name: 'courseExpLessonExp',
                    component: () => import(/* webpackChunkName: "user-course-exp-lessonExp" */ '@/views/user/course-exp-lessonExp.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/exp/view/:courseId/:id',
                    name: 'expContentView',
                    component: () => import(/* webpackChunkName: "lesson-exp-content-view" */ '@/views/lesson/exp/exp-content-view.vue'),
                    meta: {requireAuth: true}
                }, // 实验资源预览部分
                {
                    path: '/shenbaoexp/:id',
                    name: 'shenbaoExp',
                    component: () => import(/* webpackChunkName: "declare-shenbao-exp" */ '@/views/declare/shenbao-exp.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/lessonDept',
                    name: 'lessonDept',
                    component: () => import(/* webpackChunkName: "lesson-dept" */ '@/views/lesson/dept/lesson-dept.vue'),// 机构部门
                    meta: {requireAuth: false}
                },
                {
                    path: '/course/base',
                    name: 'baseCourse',
                    component: () => import(/* webpackChunkName: "lesson-base" */ '@/views/lesson/base-course.vue'), // 基础课程
                    meta: {requireAuth: false}
                },
                {
                    path: '/course',
                    name: 'lessonMajor',
                    component: () => import(/* webpackChunkName: "lesson-major" */ '@/views/lesson/dept/lesson-major.vue'),// 实训课程
                    meta: {requireAuth: false}
                },
                {
                    path: '/deptBrief/:deptId',
                    name: 'deptBrief',
                    component: () => import(/* webpackChunkName: "user-lesson" */ '@/views/lesson/dept/dept-brief.vue'),
                    meta: {requireAuth: false}
                },
                {
                    path: '/personal',
                    name: 'personal',
                    component: () => import(/* webpackChunkName: "user-personal" */ '@/views/user/personal.vue'),
                    meta: {requireAuth: true},
                    redirect: {name: 'userLesson'},
                    children: [
                        {
                            path: 'lesson',
                            name: 'userLesson',
                            component: () => import(/* webpackChunkName: "user-lesson" */ '@/views/user/user-lesson.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'attend',
                            name: 'userAttend',
                            component: () => import(/* webpackChunkName: "user-attend" */ '@/views/user/user-attend.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'dept',
                            name: 'mydept',
                            component: () => import(/* webpackChunkName: "user-dept" */ '@/views/user/user-dept.vue'),
                            meta: {requireAuth: true}
                        },
                        { path: 'contests', name: 'userContests', component: userContests, meta: { requireAuth: true } },
                        {
                            path: 'room',
                            name: 'userRoom',
                            component: () => import(/* webpackChunkName: "user-room" */ '@/views/user/user-room.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'supervise',
                            name: 'userSupervise',
                            component: () => import(/* webpackChunkName: "user-supervise" */ '@/views/user/user-supervise.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'bank',
                            name: 'userBank',
                            component: () => import(/* webpackChunkName: "user-bank" */ '@/views/user/user-bank.vue'),
                            meta: {requireAuth: true}
                        },
                        // 实验申报
                        {
                            path: 'shenbao',
                            name: 'userShenbao',
                            component: () => import(/* webpackChunkName: "user-shenbao" */ '@/views/user/user-declare.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'management',
                            name: 'userManagement',
                            component: () => import(/* webpackChunkName: "user-management" */ '@/views/user/user-management.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'myTest',
                            name: 'userMytest',
                            component: () => import(/* webpackChunkName: "user-test" */ '@/views/user/user-mytest.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'exercise',
                            name: 'userExercise',
                            component: () => import(/* webpackChunkName: "user-exercise" */ '@/views/user/user-exercise.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'traincount',
                            name: 'userTraincount',
                            component: () => import(/* webpackChunkName: "user-traincount" */ '@/views/user/user-traincount.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'wrongbook',
                            name: 'userWrongbook',
                            component: () => import(/* webpackChunkName: "user-wrongbook" */ '@/views/user/user-wrongbook.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'chapters',
                            name: 'chapters',
                            component: () => import(/* webpackChunkName: "exam-chapters" */ '@/views/exam/chapters/index.vue'),
                            meta: {requireAuth: true}
                        }, // 通用数据 - 章节管理
                        {
                            path: 'knowledgepoints',
                            name: 'knowledgepoints',
                            component: () => import(/* webpackChunkName: "exam-knowledge-points" */ '@/views/exam/knowledgepoints/index.vue'),
                            meta: {requireAuth: true}
                        }, // 通用数据 - 知识点管理
                        {
                            path: 'dynamic',
                            name: 'dynamic',
                            component: () => import(/* webpackChunkName: "dynamic" */ '@/views/dynamic/dynamic.vue'),
                            meta: {requireAuth: true}
                        },
                        {
                            path: 'appoint',
                            name: 'appoint',
                            component: () => import(/* webpackChunkName: "user-appoint" */ '@/views/user/user-appoint.vue'),
                            meta: {requireAuth: true}
                        }, // 我的预约
                        {
                            path: 'course',
                            name: 'userCourse',
                            component: () => import(/* webpackChunkName: "user-course" */ '@/views/user/user-course.vue'),
                            meta: {requireAuth: true}
                        }, // 我的课程
                        {
                            path: 'report',
                            name: 'userReport',
                            component: () => import(/* webpackChunkName: "user-report" */ '@/views/user/user-report.vue'),
                            meta: {requireAuth: true}
                        }, // 实验报告
                    ]
                },
                {
                    // type：bind、login
                    path: '/third-party/wecat/:type',
                    name: 'thirdPartyWecat',
                    component: () => import(/* webpackChunkName: "third-party-wecat" */ '@/components/third-party/wecat/redirect.vue'),
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/users/profile',
                    name: 'profile',
                    component: () => import(/* webpackChunkName: "user-profile" */ '@/views/user/profile.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/users/message',
                    name: 'message',
                    component: () => import(/* webpackChunkName: "user-message" */ '@/views/user/message.vue'),
                    meta: {requireAuth: true}
                },
                {
                    path: '/lesson/:lessonUid/exp/:uid',
                    name: 'expUser',
                    component: expUserList,
                    meta: {requireAuth: true}
                },
                {
                    path: '/test',
                    name: 'test',
                    component: () => import(/* webpackChunkName: "test-common" */ '@/views/test/components/test.vue'),
                    redirect: '/tests',
                    children: [
                        {
                            path: '/tests',
                            name: 'tests',
                            component: () => import(/* webpackChunkName: "test-list" */ '@/views/test/test-list.vue'),
                            meta: {requireAuth: true}
                        },
                    ]
                },
                {path: '/test/modifypaper', name: 'modifyPaper', component: editExamPaper, meta: {requireAuth: true}}, // 修改试题
                {
                    path: '/exam/:id/details',
                    name: 'examDetails',
                    component: () => import(/* webpackChunkName: "exam-details" */ '@/views/exam/etexam/details.vue'),
                    meta: {requireAuth: true}
                }, // 考试详情
                {
                    path: '/exam/:id/scoring/list',
                    name: 'testMarking',
                    component: () => import(/* webpackChunkName: "test-marking" */ '@/views/test/marking.vue'),
                    meta: {requireAuth: true}
                }, // 查看阅卷列表
                {
                    path: '/exam/etfield/:fieldId',
                    name: 'questionList',
                    component: () => import(/* webpackChunkName: "exam-question" */ '@/views/exam/question.vue'),
                    meta: {requireAuth: true}
                }, // 题库列表
                {path: '/exam/paper', name: 'addExamPaper', component: editExamPaper, meta: {requireAuth: true}}, // 新增试卷
                {path: '/exam/paper/:id', name: 'editExamPaper', component: editExamPaper, meta: {requireAuth: true}}, // 编辑试卷
                {
                    path: '/test/newTest/:testUid/:step',
                    name: 'newTest',
                    component: () => import(/* webpackChunkName: "test-add" */ '@/views/test/new-test.vue'),
                    meta: {requireAuth: true}
                }, // 创建新考试
                {
                    path: '/exercise/rehearsalList',
                    name: 'rehearsalList',
                    component: () => import(/* webpackChunkName: "exercise-rehearsalList" */ '@/views/exercise/rehearsalList.vue'),
                    meta: {requireAuth: true}
                }, // 练习页面排行榜
                {
                    path: '/exercise/practiceAnalysis',
                    name: 'practiceAnalysis',
                    component: () => import(/* webpackChunkName: "exercise-practice-analysis" */ '@/views/exercise/practice-analysis.vue'),
                    meta: {requireAuth: true}
                }, // 个人练习分析
            ]
        },
        {
            path: '/mylesson/:lessonUid/exp/:uid', name: 'expMine', component: expUserList, meta: {requireAuth: true}
        },
        {
            path: '/test/preview/:id',
            name: 'testPreview',
            component: () => import(/* webpackChunkName: "test-preview" */ '@/views/test/test-preview.vue'),
            meta: {requireAuth: true}
        }, // 试卷预览
        {
            path: '/exam/question/:questionId/edit',
            name: 'editTestQuestion',
            component: editTestQuestion,
            meta: {requireAuth: true}
        }, // 编辑题目
        {
            path: '/exam/:fieldId/question/add',
            name: 'addTestQuestion',
            component: editTestQuestion,
            meta: {requireAuth: true}
        }, // 添加题目
        {
            path: '/exam/:id/instructions',
            name: 'testInstructions',
            component: () => import(/* webpackChunkName: "test-instructions" */ '@/views/test/test-instructions.vue'),
            meta: {requireAuth: true}
        }, // 考前须知
        {
            path: '/exam/:recordId/see',
            name: 'testView',
            component: () => import(/* webpackChunkName: "test-view" */ '@/views/test/test-view.vue'),
            meta: {requireAuth: true}
        }, // 查看考试
        {
            path: '/exam/:id/:recordId/practice',
            name: 'testPractice',
            component: () => import(/* webpackChunkName: "test-practice" */ '@/views/test/practice.vue'),
            meta: {requireAuth: true}
        }, // 答题卡
        {
            path: '/exam/:id/:recordId/scoring/previewExam',
            name: 'markingDetails',
            component: () => import(/* webpackChunkName: "test-marking-details" */ '@/views/test/test-marking-details.vue'),
            meta: {requireAuth: true}
        }, // 考试阅卷
        {
            path: '/exam/practice/:id/begin',
            name: 'examPracticeBegin',
            component: () => import(/* webpackChunkName: "exam-practice-begin" */ '@/views/exam/practice/begin.vue'),
            meta: {requireAuth: true}
        }, // 考试练习页面
        {
            path: '/exam/practice/statistics/user/:id',
            name: 'examPracticeStatisticsUser',
            component: () => import(/* webpackChunkName: "exam-practice-statistics-user" */ '@/views/exam/practice/statistics-user.vue'),
            meta: {requireAuth: true}
        }, // 用户的练习统计
        {
            path: '/lesson/task/marking/:uid',
            name: 'lessonTaskMarking',
            component: () => import(/* webpackChunkName: "lesson-task-marking" */ '@/views/lesson/task/lesson-task-marking.vue'),
            meta: {requireAuth: true}
        }, // 批阅作业
        {
            path: '/lesson/group/list/:uid',
            name: 'lessonGroupList',
            component: () => import(/* webpackChunkName: "lesson-group-list" */ '@/views/lesson/group/list.vue'),
            meta: {requireAuth: true}
        }, // 课堂分组列表
        {
            path: '/lesson/group/:uid',
            name: 'lessonGroup',
            component: () => import(/* webpackChunkName: "lesson-group-team" */ '@/views/lesson/group/team.vue'),
            meta: {requireAuth: true}
        }, // 课堂分组小组列表
        {
            path: '/lesson/exp/document/:uid/:fileUid',
            name: 'lessonExpDocument',
            component: () => import(/* webpackChunkName: "lesson-exp-document" */ '@/views/lesson/exp/lesson-exp-document.vue'),
            meta: {requireAuth: true}
        },
        {   path: '/lesson/:labLessonUid/exp/:labExpUid/lineup/:type',
            name: 'lessonExpLineup',
            component: () => import(/* webpackChunkName: "lesson-exp-lineup" */ '@/views/lesson/exp/lesson-exp-lineup'),
            meta: {requireAuth: false}
        },
        {
            path: '/lesson/exp/start/:labExpUid/:uid/:ticket/:type',
            name: 'lessonExpStart',
            component: expRunPage,
            meta: {requireAuth: true}
        },
        {
            path: '/lesson/exp/start/:labExpUid/:uid/:ticket/:type/:key',
            name: 'shenbaoExpStart',
            component: expRunPage,
            meta: {requireAuth: true}
        },
        {
            path: '/lesson/exp/loaclstart/:labExpUid/:uid/:expUid/:lessonUid',
            name: 'lessonLocalExpStart',
            component: () => import(/* webpackChunkName: "lesson-exp-local-runing" */ '@/views/lesson/exp/lesson-exp-local-runing.vue'),
            meta: {requireAuth: true}
        },
        {
            path: '/lesson/exp/:uid/marking',
            name: 'lessonExpMarking',
            component: () => import(/* webpackChunkName: "lesson-exp-marking" */ '@/views/lesson/exp/lesson-exp-marking.vue'),
            meta: {requireAuth: true}
        }, // 批阅报告
        { path: '/race/exp/:expUid/group/:groupUid/marking', name: 'raceExpMarking', component: lessonExpMarking, meta: { requireAuth: true } }, // 批阅报告
        { path: '/race/exp/:uid/runing', name: 'raceExpRuning', component: raceExpRuning, meta: { requireAuth: true } }, // 做竞赛实验项目
        {
            path: '/sub',
            component: () => import(/* webpackChunkName: "common-sub" */ '@/components/common/sub.vue'),
            children: [
                {
                    path: '/lesson/teacherStatic/:teacherId',
                    name: 'teacherStatic',
                    component: () => import(/* webpackChunkName: "statistical-teacher" */ '@/views/statistical/teacher.vue'),
                    meta: {requireAuth: true}
                }, // 教学统计数据大屏
                {
                    path: '/lesson/platformStatic',
                    name: 'platformStatic',
                    component: () => import(/* webpackChunkName: "statistical-platform" */ '@/views/statistical/platform.vue'),
                    meta: {requireAuth: true}
                }, // 平台统计数据大屏
                {
                    path: '/lesson/theuserStatic/:userId',
                    name: 'theuserStatic',
                    component: () => import(/* webpackChunkName: "statistical-theuser" */ '@/views/statistical/theuser.vue'),
                    meta: {requireAuth: true}
                }, // 用户统计数据大屏
                {
                    path: '/lesson/:uid/coursedata',
                    name: 'lessonData',
                    component: () => import(/* webpackChunkName: "lesson-coursedata" */ '@/views/lesson/coursedata/index.vue'),
                    meta: {requireAuth: true}
                }, // 课堂数据统计
                {
                    path: '/lesson/:uid/coursedata/:studentId',
                    name: 'lessonDataStudy',
                    component: () => import(/* webpackChunkName: "lesson-coursedata-study" */ '@/views/lesson/coursedata/index-study.vue'),
                    meta: {requireAuth: true}
                }, // 课堂数据统计
                {
                    path: '/task/:uid/taskDetails',
                    name: 'taskDetails',
                    component: () => import(/* webpackChunkName: "lesson-task-details" */ '@/views/lesson/task/task-details.vue'),
                    meta: {requireAuth: true}
                }, // 课堂数据统计
                {
                    path: '/exp/:uid/expDetails',
                    name: 'expDetails',
                    component: () => import(/* webpackChunkName: "lesson-exp-details" */ '@/views/lesson/exp/components/exp-details.vue'),
                    meta: {requireAuth: true}
                }, // 课堂实验数据统计
            ]
        },
        {
            path: '/edu/:key',
            name: 'shenbaoV1',
            component: () => import(/* webpackChunkName: "declare-shenbao_v1" */ '@/views/declare/shenbao_v1.vue'),
            meta: {requireAuth: false}
        },   // 申报实验子页面
        {
            path: '/404',
            name: 'views404',
            component: () => import(/* webpackChunkName: "common-404" */ '@/components/common/404.vue'),
            meta: {requireAuth: false}
        },   // 申报实验子页面
        {
            path: '/edu/:key/detail',
            name: 'shenbaoV2',
            component: () => import(/* webpackChunkName: "declare-shenbao_v2" */ '@/views/declare/shenbao_v2.vue'),
            meta: {requireAuth: false}
        },   // 申报实验子页面
        {
            path: '/userPact',
            name: 'fmPact',
            component: () => import(/* webpackChunkName: "common-fmaster-pact" */ '@/components/common/fmaster-pact.vue'),
            meta: {requireAuth: false}
        }, // 用户协议
        {
            path: '/WincourseGuide',
            name: 'WincourseGuide',
            component: () => import(/* webpackChunkName: "common-register" */ '@/components/common/WincourseGuide.vue')
        }, // 跳转云课时间引导
        {
            path: '/register',
            name: 'fmRegister',
            component: () => import(/* webpackChunkName: "common-register" */ '@/components/common/register.vue')
        }, // 用户注册
        {
            path: '/wincourseLoad/:code',
            name: 'wincourseLoad',
            component: () => import(/* webpackChunkName: "common-register" */ '@/components/common/wincourse-loading.vue')
        }, // 云课跳实验工坊
        { path: '/reset/password', name: 'resetPassword', component: () => import(/* webpackChunkName: "reset-password" */ '@/pages/reset-password/Index.vue'), meta: { title: '重置密码' } },
        { path: '/createOrBindUser/wincourse', name: 'createOrBindWincourseUser', component: () => import(/* webpackChunkName: "bind-user-wincourse" */ '@/views/wincourse/CreateOrBindUser.vue'), meta: { title: '账号绑定' } },
    ]
});

Router.beforeEach((to, from, next) => {
    NProgress.start()
    // 判断该路由是否需要登录权限
    if (from.path !== '/' && to.meta.requireAuth) {
        if (store.getters.token) {
            next()
        } else {
            if (to.name === 'thirdPartyWecat' && to.params.type === 'login') {
                next()
            } else {
                Message({
                    message: '请先登录',
                    type: 'error'
                })
                next({path: from.path})
                NProgress.done()
            }
        }
    } else {
        next()
    }
})

Router.afterEach(() => {
    NProgress.done()
    window.scrollTo(0, 0)
})

export default Router;
